"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenLinkIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var OpenLinkIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "currentColor", d: "M16.9383542,18.9270833 L5.07291667,18.9270833 L5.07291667,7.0610625 L11.6793125,7.0610625 L11.6793125,9.04979167 L7.0400625,9.04979167 L7.0400625,16.9600833 L14.9503542,16.9600833 L14.9503542,12.3424167 L16.9385,12.3424167 L16.9383542,18.9270833 Z M18.9270833,10.3319583 L16.9383542,10.3319583 L16.9383542,8.472 L11.7003125,13.6888958 L10.3109146,12.2989292 L15.5489563,7.0608875 L13.6889979,7.0608875 L13.6889979,5.07274167 L18.9270833,5.07274167 L18.9270833,10.3319583 Z", fillRule: "nonzero" })))); };
exports.OpenLinkIcon = OpenLinkIcon;
